export default __webpack_public_path__ + "locales/nl/DeleteDialog.json?hash=a851f305a80fde9ec6a5b641fe52a3d1";